import {useRunWorkflow} from '@/biz/workflow.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default props => {
    const runWorkflow = useRunWorkflow()
    const map = useMapContext()

    if ('_ISRF_MAP' !== map.data.mapTypeCode) {
        return null
    }

    const {prjId, prjMapFlag, pkid, prjNo, prjName, isrfName} = map.root.data

    const onClick = async () => {
        const [isrfBranch] = map.queryNodes({
            data: {bizNodeType: 'ISRF_BRANCH'}
        })

        if (! (prjMapFlag || isrfBranch.firstChild)) {
            await map.isrf.createBranch()
        }

        const bizMap = {prjId, pkid, prjNo, prjName, isrfName}
        runWorkflow({bizMap, scene: 'GENERATE_UPT'})
    }


    return {
        label: prjMapFlag ? 'AI迭代Spec模型' : 'AI构建增量模型',
        onClick,
        ...props
    }
}
